import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageService, Message, ConfirmationService, ConfirmEventType } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CaseService } from '../../services/case.service';
import { UtilitiesService } from '../../services/utilities.service';
import { DatePipe, formatCurrency } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';

import { ApplicationCaseDto } from './dto/application-case.dto';
import { ApplicationPropertyDto } from './dto/application-property.dto';
/*
import { ApplicationAssessorDto } from './dto/application-assessor.dto';
import { ApplicationValueDto } from './dto/application-value.dto';
import { ApplicationFactsDto } from './dto/application-facts.dto';
import { IApplicant } from 'src/app/shared/classes/applicant';
import { IAgency } from 'src/app/shared/classes/agency';
*/

@Component({
  selector: 'app-backload-case',
  templateUrl: './old-case.component.html',
  providers: [ ConfirmationService, MessageService]
})
export class CaseOldComponent implements OnInit {

  // @Input() caseId: string;
  userRole: string;
  userName: string;
  assignByNumber = false; // whether to prompt for specific Case# or will be assigned automatically
  assignedCaseNumber = '';
  curYear: number = new Date().getFullYear();
  caseYear: number;
  yearList: string[];

  tdy: Date;
  caseId: string;
  numAccordionTabs = 9;
  // accordionOpenIndex = [0, 1, 2, 3, 4, 5, 6, 7, 8];
  accordionOpenIndex = [];
    applicationCase: any; // ApplicationCaseDto;
    applicationProperty: any; // ApplicationPropertyDto;
    applicationApplicant: any; // IApplicant;
    applicationAgent: any; // IAgency;
    applicationAssessor: any; // ApplicationAssessorDto;
  applicationValues: any;
  applicationFacts: any;
  applicationDocs: any;

  myApplication: any; // composite object containing ALL fields, child-objects associated w/ case

  isBackloadCase = true;    // indicates this is an old case being backloaded - rod
  isNewCase = false;

  isLateCase = false;
  saveAsLate = '';
  isInsufficientCase = false;
  whyInsufficient = '';
  saveAsInsufficient = '';
  isPaid: boolean ;
  okToSave = false;

  daysToExpiration: number;

  eFileId: number;  // E-File Application ID


  applicantType: string;
  accordionDataCounter = 0;

  displayState: any = {
    workingDiv: false,
    caseDiv: false,
  };

  diagPosition: string; // confirmation/dialog position
  yearRange: string = '';

  constructor(private caseService: CaseService, private utilService: UtilitiesService, private router: Router, route: ActivatedRoute,
              private datePipe: DatePipe, private messageService: MessageService, private confirmationService: ConfirmationService, private cookieService: CookieService) {

    this.applicationCase = new ApplicationCaseDto();
    this.applicationProperty = new ApplicationPropertyDto();
  }


    ngOnInit() {
        const uRole = this.cookieService.get('userRole'); // get the role from login cookie
        if (uRole) {
          this.userRole = uRole;
        } else {
        }
        this.userName = this.cookieService.get('userName');
        this.getYearList(); // construct list of years available for backloading cases - rod 12/23/2025

        const curYear = this.curYear;
        this.yearRange = curYear - 10 + ':' + curYear;
        this.createCase();
        this.openAllSections();
    }

  // generate a list of years to display, based on current year
  getYearList() {
    this.yearList = [];
    const baseYr = this.curYear - 6;
    for (let yr = this.curYear -1; yr > baseYr; yr--) {
      this.yearList.push(yr.toString());
    }
    this.caseYear = this.curYear - 1; // default to previous year so they don't have to keep selecting it
  }

  createCase() {
        this.caseId = '';
        this.assignedCaseNumber = '';
        this.initializeCaseObj();
        this.isNewCase = true;      // setting this flag will disable some of the accordion tabs until the case has been saved, i.e. documents, e-filed docs, minutes, etc
        this.okToSave = false;      // flag will be set to true once the application data has been validated (see: validateCase)
        this.displayState.workingDiv = false;
        this.displayState.caseDiv = true;
    }

    openAllSections() {
        this.accordionOpenIndex = [];
        for (let i = 0; i < this.numAccordionTabs; i++ ) {
        this.accordionOpenIndex.push(i);
        }
    }

    closeAllSections() {
        this.accordionOpenIndex = [];
    }

    receiptChange() {
        // if there is a Receipt#, the Paid value is set to True, otherwise it is False
        this.isPaid = this.applicationCase.receiptNum ? true : false;
    }

    getDaysToExpiration(): number {
        let myDate: Date;
        const totNumDays = this.calcDaysToExpiration(); // # of days allowed until Application expires (default = 2 years)
        const myToday = new Date();
        // determine which date to use as the starting point
        // NOTE: if Application was E-Filed, we'll use the Received Date ??
        if (this.applicationCase.datePostmarked) {
        myDate = this.applicationCase.datePostmarked;
        } else if (this.applicationCase.dateReceived) {
        myDate = this.applicationCase.dateReceived;
        }
        /*
        const diffTime: number = Math.abs(myToday - myDate);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24);
        return totNumDays - this.getDateDiff();
        */
        return 101; // DURING TESTING!! -- return this value so as not to forget we need to finish implementing the logic in this method
    }

    // calculate # of days between date when application was submitted (E-Filed) or Postmarked and the same date two years in future
    // NOTE: we need to account for Leap Years, et al (factors?)
    calcDaysToExpiration(): number {
        let myDate: Date;
        if (this.applicationCase.datePostmarked) {
        myDate = this.applicationCase.datePostmarked;
        } else if (this.applicationCase.dateReceived) {
        myDate = this.applicationCase.dateReceived;
        }
        let myDay = myDate.getDate(), myMonth = myDate.getMonth() + 1, myYear = myDate.getFullYear();
        if (myDay == 29) {  // if this is Feb 29th, should the future date be Feb 28th or Mar 01?
        myDay = 28;
        }
        // get same date, 2 years in future
        const nDate = (myYear + 2) + '-' + myMonth + '-' + myDay;
        const futureDate = new Date(nDate);
        const diffDays = this.utilService.convertDateToDays(futureDate) - this.utilService.convertDateToDays(myDate);
        return diffDays;
    }

    // calculate the # of days between today and the application's postmarked/efiled date
    getDateDiff(): number {
        const myToday = new Date();
        let myDate: Date;
        if (this.applicationCase.datePostmarked) {
        myDate = this.applicationCase.datePostmarked;
        } else if (this.applicationCase.dateReceived) {
        myDate = this.applicationCase.dateReceived;
        }
        this.utilService.doAudit('myDate: ' + myDate + '; myToday: ' + myToday);
        const diffDays = this.utilService.convertDateToDays(myToday) - this.utilService.convertDateToDays(myDate);
        this.utilService.doAudit(diffDays, 'diffDays:');
        return diffDays;
    }

    // handle data changes in child components here...
    updateApplicant(myApplicant: any) {
        this.utilService.doAudit(myApplicant, 'data change event received from child component: Applicant');
        this.applicationApplicant = myApplicant;
    }

    updateAgent(myAgent: any) {
        this.utilService.doAudit(myAgent, 'data change event received from child component: Agent');
        this.applicationAgent = myAgent;
        this.utilService.doAudit(this.applicationAgent, 'application agent object');
    }

    updateProperty(myProperty: any) {
        this.utilService.doAudit(myProperty, 'data change event received from child component: Property');
        this.applicationProperty = myProperty;
    }
    updateValues(myValues: any) {
        this.utilService.doAudit(myValues, 'data change event received from child component: Values');
        this.applicationValues = myValues;
    }

    updateFacts(myFacts: any) {
        this.utilService.doAudit(myFacts, 'data change event received from child component: Facts');
        this.applicationFacts = myFacts;
    }

    updateDocs(myDocs: any) {
        this.utilService.doAudit(myDocs, 'data change event received from child component: Documents');
        this.applicationDocs = myDocs;
    }

    // Mapping and Saving functions go here...

    // initialize composite Case object
    initializeCaseObj() {
        this.myApplication = {
        case: {},
        applicant: {},
        agency: {},
        property: {},
        caseValue: {
            assessType: '',
            totalValue: null,
            valueDifference: null,
            applicantGroup: {},
            assessorGroup: {},
            opinionGroup: {},
            finalGroup: {},
            isHighValue: null,
        },
        caseFacts: [],
        caseStatus: '',
        efileId: '',
        };
    }

    editCase(appId: string) {
       this.router.navigate(['/case/' + appId]);
        // clear current data and continue backloading...
    }

    clearCase() {

    }
    // exit case without saving any data!
    exitCase() {
        // this.showInfo({key:'info', severity: 'success', summary: 'System Message', detail: 'Exiting Case module' });
        this.router.navigate(['/caselookup']);
    }

    // maintain an audit trail...
    updateAuditTrail(msg: string) {
        // for now, add an entry at the end of Case Comments reflecting who saved the case and when...
        const tdy = this.utilService.formatDate(null, '/', false, true);  // this should return the current date/time...
        let cmt = this.applicationCase.comment;
        cmt = (cmt ? cmt + '\n' : '') + msg + tdy;
        this.utilService.doAudit(cmt, 'adding audit trail comment:');
        this.applicationCase.comment = cmt;
        // consider making an entry in an AuditTrail table...
    }

    validateCaseNum(): any {
      // we are assigning a specific case # to this case; validate it!
        const caseNum = this.assignedCaseNumber;
        if ( (caseNum == null) || (caseNum.length == 0)) {
            alert('Please enter a valid Case# (e.g. 24-0001)');
            return;
        }
        const tYear = parseInt(caseNum.split('-')[0]) ;
        const curYear = new Date().getFullYear() - 2000;
        const baseYear = curYear - 10;
        this.utilService.doAudit(caseNum, 'case#');
        this.utilService.doAudit(curYear + '; ' + tYear, 'cur Year; case Year');
        if ( tYear == curYear ) {
          alert('Sorry! Can not backload cases for the current year: ' + (tYear + 2000));
          return;
        } else if ( (tYear < baseYear) || (tYear > (curYear - 1)) || (isNaN(tYear)) ) {
            alert('Invalid Case Year: ' + (tYear + 2000) + '; can not be blank or earlier than ' + (baseYear + 2000));
            return;
        }
        this.caseService.searchCase('casenum', caseNum).subscribe(data => {
            if (data) {
                if (data.length > 0) {
                    alert('This Case # (' + caseNum + ') has already been assigned!');
                    return false;
                } else {
                    this.validateCase();
                }
            } else {
              alert('Unable to confirm Case# does not already exist!');
              return false;
            }
        });
    }
    validateCaseYear() {
      const caseYear = this.caseYear;
      this.utilService.doAudit(caseYear, 'caseyear: ');
      if ( (caseYear == null) || (caseYear < 1 ) ) {
        alert('Please select the year in which the case will be filed (e.g. 2024)');
        return;
      }
      this.validateCase();
    }
    //
    // validate application; check for filing date (checkLate) and missing data (checkInsufficient)
    validateCase(): any {
        this.utilService.doAudit('hit validateCase function', '');
        this.clearAll();
        const retObj = {
            isLate: false,
            isInsufficient: false
        };
        this.okToSave = false;
        retObj.isLate = this.checkLate();
        retObj.isInsufficient = this.checkInsufficient();
        this.utilService.doAudit(retObj, 'validate case results:');
        // alert(this.whyInsufficient);
        if (retObj.isLate === true) {
            this.okToSave = false;
            const ans = this.confirm1('Application will be saved as LATE.<br /><br />Is this OK?', 'top');
        } else if (retObj.isInsufficient === true) {
            this.okToSave = false;
            this.confirm1(this.whyInsufficient + '<br /><br />Do you wish to save application as Insufficient?', 'top-right');
        } else {
            this.okToSave = false;
            let msg = 'Ready to file case for year: ' + this.caseYear;
            if (this.assignByNumber) {
              msg = 'Ready to file Case #: ' + this.assignedCaseNumber;
            }
            msg = msg + '\n\nOK to continue?';
            this.confirm1(msg, 'top');
        }
        return retObj;
    }

    confirm1(msg: string, position: string) {
        this.diagPosition = position;

        this.confirmationService.confirm({
            message: msg,
            header: 'Confirmation',
            icon: 'pi pi-info-circle',
            accept: () => {
                this.messageService.add({key: 'info', severity: 'info', summary: 'Confirmed', detail: 'Filing data'});
                this.okToSave = true;
                this.saveCase();
            },
            reject: (type) => {
                switch (type) {
                    case ConfirmEventType.REJECT:
                        // this.messageService.add({key: 'toast', severity:'info', summary:'Cancelled', detail:'Nothing saved. Continue editing application'});
                    break;
                    case ConfirmEventType.CANCEL:
                        // this.messageService.add({key: 'toast', severity:'warn', summary:'Cancelled', detail:'You have cancelled'});
                    break;
                }
            },
            key: 'positionDialog'
        });

    }

    // determine if can file this type of application at this time
    // if invalid date, return TRUE
    checkLate(): boolean {
        let myD = this.applicationCase.dateReceived;
        if (myD === null || myD === undefined) {
            this.isLateCase = false;
            return false;
        }
        let mo, day, mp, dp;
        const caseType = this.applicationValues;
        if (this.applicationValues) {
            if (this.applicationValues.caseInfo.assessType !== 'Regular') {
                this.isLateCase = false;
                return false;
            }
            /*
            if (this.applicationValues.caseInfo.assessType === 'Supplemental' || this.applicationValues.caseInfo.assessType === 'Roll Change'
            || this.applicationValues.caseInfo.assessType === 'Escape'  ){
                this.isLateCase = false;
                return false;
            } */
        } else {
            this.isLateCase = false;
            return false;
        }
        mo = myD.getMonth() + 1;
        day = myD.getDate();
        if ( (mo == 7 && day > 1) || (mo > 7 && mo < 12) ) {
            this.isLateCase = false;
            return false;
        }
        // look at postmark date
        myD = this.applicationCase.datePostmarked;
        if (myD) {
            mo = myD.getMonth() + 1;
            day = myD.getDate();
            if ( (mo == 7 && day > 1) || (mo > 7 && mo < 12) ) {
                this.isLateCase = false;
                return false;
            }
        }
        this.isLateCase = true;
        this.saveAsLate = 'Save as LATE';
        return true;
    }

    // determine if required items have been entered
    // if missing data, return TRUE
    checkInsufficient(): boolean {
        let why = '';
        let rollValuePerApplicant = false;
        let rollValueOpinion = false;
        //
        this.utilService.doAudit(this.myApplication, 'myApplication');

        // applicant stuff
        if (this.applicationApplicant.sign === null || this.applicationApplicant.sign === false ){
            if (why !== '' ){why = why + '<br />'; }
            why = why + 'Applicant Original Signature';
        }

        if (this.applicationApplicant) {
            if (this.applicationApplicant.name == '' ){
                if (why !== '' ){why = why + '<br />'; }
                why = why + 'Applicant Name';
            }
            if (this.applicationApplicant.strAddr == '' || this.applicationApplicant.city == '' || this.applicationApplicant.state == '' || this.applicationApplicant.zip == ''){
                if (why !== '' ){why = why + '<br />'; }
                why = why + 'Applicant Address';
            }
            if (this.applicationApplicant.notNotarized === true ){
                if (why !== '' ){why = why + '<br />'; }
                why = why + 'Applicant Signature Notarized';
            }
        } else {
            if (why !== '' ){why = why + '<br />'; }
            why = why + 'Applicant information';
        }
        if (this.applicationAgent) {
            // agency stuff
            if (this.applicationAgent.name !== '' || this.applicationAgent.contact !== '' ) {
                if (this.applicationAgent.sign === null ) {
                    this.applicationAgent.sign = false;
                }
                if (this.applicationAgent.signNoNeed === null ) {
                    this.applicationAgent.signNoNeed = false;
                }
                if (this.applicationAgent.sign === false && this.applicationAgent.signNoNeed === false ) {
                    if (why !== '' ){why = why + '<br />'; }
                    why = why + 'Agency Authorizing Signature';
                }
                if (this.applicationAgent.name === '' ){
                    if (why !== '' ){why = why + '<br />'; }
                    why = why + 'Agent Company Name';
                }
                if (this.applicationAgent.strAddr === '' || this.applicationAgent.city === '' || this.applicationAgent.state === '' || this.applicationAgent.zip === ''){
                    if (why !== '' ){why = why + '<br />'; }
                    why = why + 'Complete Agent Address';
                }
            }
        }
        // Property
        if (this.applicationProperty) {
            if (!this.applicationProperty.apn && !this.applicationProperty.unsecuredNum){
                if (why !== '' ){why = why + '<br /> '; }
                why = why + 'APN or Unsecured Number';
            }
            if (this.applicationProperty.strNum === '' || this.applicationProperty.street === '' || this.applicationProperty.city === '' ){
                if (why !== '' ){why = why + '<br />'; }
                why = why + 'Complete Situs';
            }
        } else {
            if (why !== '' ){why = why + '<br />'; }
            why = why + 'Property/Situs info';
        }
        // Values
        if (this.applicationValues) {
            if (this.applicationValues.valueApplicant.landValue !== null || this.applicationValues.valueApplicant.mineralValue !== null || this.applicationValues.valueApplicant.improveValue !== null ) {
                rollValuePerApplicant = true;
            }
            if (this.applicationValues.valueApplicant.treesValue !== null || this.applicationValues.valueApplicant.fixturesValue !== null || this.applicationValues.valueApplicant.personalValue !== null ) {
                rollValuePerApplicant = true;
            }
            if (this.applicationValues.valueApplicant.exemptValue !== null || this.applicationValues.valueApplicant.penaltyValue !== null || this.applicationValues.valueApplicant.netValue !== null ) {
                rollValuePerApplicant = true;
            }
            if (rollValuePerApplicant === false ){
                if (why !== '' ){why = why + '<br />'; }
                why = why + 'Value on Roll per Applicant';
            }
            if (this.applicationValues.valueOpinion.landValue !== null || this.applicationValues.valueOpinion.mineralValue !== null || this.applicationValues.valueOpinion.improveValue !== null ) {
                rollValueOpinion = true;
            }
            if (this.applicationValues.valueOpinion.treesValue !== null || this.applicationValues.valueOpinion.fixturesValue !== null || this.applicationValues.valueOpinion.personalValue !== null ) {
                rollValueOpinion = true;
            }
            if (this.applicationValues.valueOpinion.exemptValue !== null || this.applicationValues.valueOpinion.penaltyValue !== null || this.applicationValues.valueOpinion.netValue !== null ) {
                rollValueOpinion = true;
            }
            if (rollValueOpinion === false ){
                if (why !== '' ){why = why + '<br />'; }
                why = why + 'Applicant Opinion of Value';
            }
            if (!this.applicationValues.caseInfo.assessType || !this.applicationValues.rollYear) {
                if (why !== '' ){why = why + '<br />'; }
                why = why + 'Assessment Type and/or Roll Year';
            }
        } else {
            if (why !== '' ){why = why + '<br />'; }
            why = why + 'Roll/Applicant Opinion Values, Assessment Type and Roll Year';
        }
        // facts
        if (this.applicationFacts) {
            // this.utilService.doAudit(this.applicationFacts,'Facts');
            if (this.applicationFacts.factsList.length === 0) {
                if (why !== '' ){why = why + '<br />'; }
                why = why + 'Supporting Facts';
            }
        } else {
            if (why !== '' ){why = why + '<br />'; }
            why = why + 'Supporting Facts';

        }

        if (why === '') {
            this.isInsufficientCase = false;
            this.whyInsufficient = '';
            this.saveAsInsufficient = '';
            return false;
        } else {
            this.isInsufficientCase = true;
            this.whyInsufficient = 'This application appears to be insufficient because the following is either missing or incomplete:<br />' + why;
            this.saveAsInsufficient = 'Save as Insufficient';
            return true;
        }
    }

    hasAssessType(): boolean {
        if (this.applicationValues) {
            if (!this.applicationValues.caseInfo.assessType || !this.applicationValues.rollYear) {
                return false;
            } else {
                return true;
            }
        } else {
            return false;
        }
    }
  saveCase() {
    if (!this.assignByNumber) {
      // case # will be auto generated by API - rod 12/23/2025
      this.saveCaseAuto();
    } else {
      // case # specified by user
      this.saveCaseByNum();
    }
    return;
  }

  saveCaseAuto(): void {
      const caseYear = this.caseYear;
      let mgmtCaseNumber = '';
      const myApplication = this.myApplication;

      // calculateTotalValue();
      this.applicationProperty.apn = this.utilService.stripDashes(this.applicationProperty.apn);

      myApplication.case = this.applicationCase;
      //
      myApplication.applicant = this.applicationApplicant;
      myApplication.case.applicantType = myApplication.applicant.type; // coz this field is stored w/ Case-related info...
      myApplication.agency = this.applicationAgent ? this.applicationAgent : null;
      myApplication.caseValue = this.mapValues();
      myApplication.property = this.applicationProperty;
      myApplication.property.rollYear = myApplication.caseValue.rollYear; // coz roll year value collected in the Values component??
      if (this.applicationFacts) {
        myApplication.caseFacts = this.applicationFacts.factsList;
        // update Case coz Claim Refund and Request Finding are collected in the FACTS component; AND convert from String values to Boolean
        myApplication.case.claimRefund = this.applicationFacts.claimRefund === 'Yes' ? true : false;
        myApplication.case.requestFinding = this.applicationFacts.requestFinding === 'Yes' ? true : false;
      }
      myApplication.efileId = this.eFileId ? this.eFileId.toString() : null;

      this.utilService.doAudit(myApplication, 'saving case; myApplication:');
      // save last applicant, agency or both (depending on what user entered)
      this.saveLastApplicant();
      this.saveLastAgency();

      let xMsg = '';
      // myApplication.caseStatus = 'Ready for Hearing';
      // theCaseYear = new Date().getFullYear();
      this.utilService.doAudit(myApplication, 'ready to save application for year: ' + caseYear + '; myApplication data:');
      //
      if (this.isLateCase === true && this.saveAsLate === 'Save as LATE') {
        myApplication.caseStatus = 'Late Application Received';
      }
      else if (this.isInsufficientCase === true && this.saveAsInsufficient === 'Save as Insufficient') {
        myApplication.caseStatus = 'Insufficient Application Received';
      }
      else if (myApplication.caseValue.isHighValue) {
        myApplication.caseStatus = 'Ready for Res Status Conference';
      }
      else {
        myApplication.caseStatus = 'Ready for Hearing';
      }
      this.updateAuditTrail('Created ');
      this.utilService.doAudit(myApplication, 'about to create case for application:');
      // create the case
      // NOTE: a Case# will be auto-generated, based on the last assigned case# for specified year
      this.caseService.createCase (myApplication, caseYear).subscribe(data => {
        this.utilService.doAudit('returned from createCase service: ' + data);
        let newAppId = '';
        if (data) {
          if (data < 0) {
            alert('Failed to save Case. If the problem persists, please notify support');
            return;
          }
          newAppId = data;  // this should be the new ApplicationId...
          // now retrieve the Case# assigned to the case
          this.caseService.getNewCaseNumber(newAppId).subscribe(dataC => {
            if (dataC.caseNum) {
              mgmtCaseNumber = dataC.caseNum;
              xMsg = 'Case saved; assigned Case#: ' + mgmtCaseNumber;
              alert(xMsg);
              // update just the comments on the case and file them... *** SERVICE NEEDS TO BE IMPLEMENTED VIA A NEW API
              this.caseService.updateCaseComments(newAppId, 'Backloaded Case#: ' + mgmtCaseNumber);
            } else {
              alert('Unable to generate new Case #');
            }
          });
          this.editCase(newAppId);  //
        } else {
          alert('Problem saving case: no response received. Please notify support');
        }
        // navigate to Case Lookup page
      });
    }
    //
    saveCaseByNum() {
        const mgmtCaseNumber = this.assignedCaseNumber;
        if (mgmtCaseNumber == '') {
            alert('No assigned Case# defined!');
            return;
        }
        const myApplication = this.myApplication;

        // calculateTotalValue();
        this.applicationProperty.apn = this.utilService.stripDashes(this.applicationProperty.apn);

        myApplication.case = this.applicationCase;
        //
        myApplication.applicant = this.applicationApplicant;
        myApplication.case.applicantType = myApplication.applicant.type; // coz this field is stored w/ Case-related info...
        myApplication.agency = this.applicationAgent ? this.applicationAgent : null;
        myApplication.caseValue = this.mapValues();
        myApplication.property = this.applicationProperty;
        myApplication.property.rollYear = myApplication.caseValue.rollYear; // coz roll year value collected in the Values component??
        if (this.applicationFacts) {
            myApplication.caseFacts = this.applicationFacts.factsList;
            // update Case coz Claim Refund and Request Finding are collected in the FACTS component; AND convert from String values to Boolean
            myApplication.case.claimRefund = this.applicationFacts.claimRefund === 'Yes' ? true : false;
            myApplication.case.requestFinding = this.applicationFacts.requestFinding === 'Yes' ? true : false;
        }
        myApplication.efileId = this.eFileId ? this.eFileId.toString() : null;

        this.utilService.doAudit(myApplication, 'saving case; myApplication:');
      // added 4/26/2023 - rod
      // save last applicant, agency or both (depending on what user entered)
        this.saveLastApplicant();
        this.saveLastAgency();

        let xMsg = '';
        // myApplication.caseStatus = 'Ready for Hearing';
        // theCaseYear = new Date().getFullYear();
        this.utilService.doAudit(myApplication, 'ready to save application for year: ' + mgmtCaseNumber + '; myApplication data:');

        if (this.isBackloadCase) {
            if (this.isLateCase === true && this.saveAsLate === 'Save as LATE') {
                myApplication.caseStatus = 'Late Application Received';
            }
            else if (this.isInsufficientCase === true && this.saveAsInsufficient === 'Save as Insufficient') {
                myApplication.caseStatus = 'Insufficient Application Received';
            }
            else if (myApplication.caseValue.isHighValue) {
                myApplication.caseStatus = 'Ready for Res Status Conference';
            }
            else {
                myApplication.caseStatus = 'Ready for Hearing';
            }
            this.updateAuditTrail('Created ');
            this.utilService.doAudit(myApplication, 'about to create case for application:');
            this.caseService.backloadCase (myApplication, mgmtCaseNumber).subscribe(data => {
                this.utilService.doAudit('returned from backloadCase service: ' + data);
                let newAppId = '';
                if (data) {
                    if (data < 0) {
                        alert('Failed to save Case. If the problem persists, please notify support');
                        return;
                    }
                    newAppId = data;  // this should be the new ApplicationId...
                    xMsg = 'Case number ' + mgmtCaseNumber + ' has been backloaded.';
                    alert(xMsg);
                    // update just the comments on the case and file them... *** SERVICE NEEDS TO BE IMPLEMENTED VIA A NEW API
                    this.caseService.updateCaseComments(newAppId, 'Backloaded Case#: ' + mgmtCaseNumber);
                    this.editCase(newAppId);
                } else {
                    alert('Problem saving case: no response received. Please notify support');
                }
                // navigate to Case Lookup page
            });
        } else {    // should not get here, but jic...
            alert('This is NOT a backloaded case.');
        }
        return;
    }

    // return composite object containing all Values + additional fields
    // get values from composite object emitted by the CaseValueComponent (upon data changed)
    mapValues() {
        let isHighValue = false;
        let rollValuePerApplicant, opinionValue, assessorValue, finalValue, caseValue, rollYear ;
        if (this.applicationValues) {
            rollValuePerApplicant = this.applicationValues.valueApplicant;
            opinionValue = this.applicationValues.valueOpinion;
            assessorValue = this.applicationValues.valueAssessor;
            finalValue = this.applicationValues.valueFinal;
            caseValue = this.applicationValues.caseInfo;
            rollYear = this.applicationValues.rollYear;
            if (rollValuePerApplicant.totalValue > 30000000) { isHighValue = true; }
        }

        // get Total value + Difference (calculated in case-value component, but could be calculated here!)
        const totalValue = this.applicationValues.valueTotal.totalValue;
        const valueDiff = this.applicationValues.valueTotal.valueDifference;
        let rollType = '';
        if (caseValue) {
            rollType = caseValue.assessType;
        }
        return {
        isHighValue,
        assessType: rollType,
        rollYear,
        totalValue,
        valueDifference: valueDiff,
        applicantGroup: rollValuePerApplicant,
        opinionGroup: opinionValue,
        assessorGroup: assessorValue,
        finalGroup: finalValue,
        };
    }
  saveLastApplicant(): void {
    this.utilService.doAudit(this.myApplication.applicant, 'last applicant to be saved:');
    const obj = JSON.stringify(this.myApplication.applicant);
    localStorage.setItem(this.userName + '-lastApplicant', obj); // username included to make it unique to user
  }
  saveLastAgency(): void {
    this.utilService.doAudit(this.myApplication.agency, 'last agency to be saved:');
    if (this.myApplication.agency) {
      const obj = JSON.stringify(this.myApplication.agency);
      localStorage.setItem(this.userName + '-lastAgency', obj);
    }
  }

    // Toaster/Message-related methods
    showToast(msg: Message) {
        this.messageService.clear('toast');
        this.messageService.add(msg);
    }

    showInfo(myMsg: Message) {
        this.messageService.clear('info');
        this.messageService.add(myMsg);
    }

    clearAll() {
        this.messageService.clear();
    }

    // DEPRECATED
    showConfirm(msgDetails: string) {
        this.confirmationService.confirm({
            message: msgDetails,
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                // this.messageService.add({key: 'info', severity:'info', summary:'Confirmed', detail:'You have accepted'});
                this.onConfirm();
            },
            reject: (type) => {
                this.onReject();
            },
            key: 'confDialog'
        });
    }

    onConfirm() {
        this.showToast({ key: 'info', severity: 'info', detail: 'Confirmed.', summary: '' });
        this.messageService.clear('conf');
    }

    onReject() {
        this.showToast({ key: 'info', severity: 'info', detail: 'Nothing done.', summary: '' });
        this.messageService.clear('conf');
    }
    checkInsufficientOLD(): boolean {
        let why = '';
        let rollValuePerApplicant = false;
        let rollValueOpinion = false;
        //
        this.utilService.doAudit(this.myApplication, 'myApplication');

        // applicant stuff
        if (this.myApplication.applicant.sign === null || this.myApplication.applicant.sign === false ){
            if (why !== '' ){why = why + ', '; }
            why = why + 'Applicant Original Signature';
        }
        if (this.myApplication.applicant.name == '' ){
            if (why !== '' ){why = why + ', '; }
            why = why + 'Applicant Name';
        }
        if (this.myApplication.applicant.strAddr == '' || this.myApplication.applicant.city == '' || this.myApplication.applicant.state == '' || this.myApplication.applicant.zip == ''){
            if (why !== '' ){why = why + ', '; }
            why = why + 'Applicant Address';
        }
        if (this.myApplication.applicant.notNotarized === true ){
            if (why !== '' ){why = why + ', '; }
            why = why + 'Applicant Signature Notarized';
        }
        // agency stuff
        if (this.applicationAgent.name !== '' || this.applicationAgent.contact !== '' ) {
            if (this.applicationAgent.sign === null ) {
                this.applicationAgent.sign = false;
            }
            if (this.applicationAgent.signNoNeed === null ) {
                this.applicationAgent.signNoNeed = false;
            }
            if (this.applicationAgent.sign === false && this.applicationAgent.signNoNeed === false ) {
                if (why !== '' ){why = why + ', '; }
                why = why + 'Agency Authorizing Signature';
            }
            if (this.applicationAgent.name === '' ){
                if (why !== '' ){why = why + ', '; }
                why = why + 'Agent Company Name';
            }
            if (this.applicationAgent.strAddr === '' || this.applicationAgent.city === '' || this.applicationAgent.state === '' || this.applicationAgent.zip === ''){
                if (why !== '' ){why = why + ', '; }
                why = why + 'Complete Agent Address';
            }
        }
        // Property
        if (!this.applicationProperty.apn && !this.applicationProperty.unsecuredNum){
            if (why !== '' ){why = why + ', '; }
            why = why + 'APN or Unsecured Number';
        }
        if (this.applicationProperty.strNum === '' || this.applicationProperty.street === '' || this.applicationProperty.city === '' ){
            if (why !== '' ){why = why + ', '; }
            why = why + 'Complete Situs';
        }
        // Values
        if (this.myApplication.caseValue.applicantGroup.landValue !== null || this.myApplication.caseValue.applicantGroup.mineralValue !== null || this.myApplication.caseValue.applicantGroup.improveValue !== null ) {
            rollValuePerApplicant = true;
        }
        if (this.myApplication.caseValue.applicantGroup.treesValue !== null || this.myApplication.caseValue.applicantGroup.fixturesValue !== null || this.myApplication.caseValue.applicantGroup.personalValue !== null ) {
            rollValuePerApplicant = true;
        }
        if (this.myApplication.caseValue.applicantGroup.exemptValue !== null || this.myApplication.caseValue.applicantGroup.penaltyValue !== null || this.myApplication.caseValue.applicantGroup.netValue !== null ) {
            rollValuePerApplicant = true;
        }
        if (rollValuePerApplicant === false ){
            if (why !== '' ){why = why + ', '; }
            why = why + 'Value on Roll per Applicant';
        }
        if (this.myApplication.caseValue.opinionGroup.landValue !== null || this.myApplication.caseValue.opinionGroup.mineralValue !== null || this.myApplication.caseValue.opinionGroup.improveValue !== null ) {
            rollValueOpinion = true;
        }
        if (this.myApplication.caseValue.opinionGroup.treesValue !== null || this.myApplication.caseValue.opinionGroup.fixturesValue !== null || this.myApplication.caseValue.opinionGroup.personalValue !== null ) {
            rollValueOpinion = true;
        }
        if (this.myApplication.caseValue.opinionGroup.exemptValue !== null || this.myApplication.caseValue.opinionGroup.penaltyValue !== null || this.myApplication.caseValue.opinionGroup.netValue !== null ) {
            rollValueOpinion = true;
        }
        if (rollValueOpinion === false ){
            if (why !== '' ){why = why + ', '; }
            why = why + 'Applicant Opinion of Value';
        }
        // facts
        if (this.myApplication.caseFacts.length === 0) {
            if (why !== '' ){why = why + ', '; }
            why = why + 'Supporting Facts';
        }

        if (why === '') {
            this.isInsufficientCase = false;
            this.whyInsufficient = '';
            this.saveAsInsufficient = '';
            return false;
        } else {
            this.isInsufficientCase = true;
            this.whyInsufficient = 'This application appears to be insufficient because the following is either missing or incomplete: ' + why;
            this.saveAsInsufficient = 'Save as Insufficient';
            return true;
        }
    }

    confirmSave(msg: string) {
        this.confirmationService.confirm({
            message: msg,
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.showInfo({key: 'info', severity: 'success', detail: 'Filing data.', summary: ''});
                // this.okToSave = true;
            },
            reject: () => {
              this.showToast({key: 'info', severity: 'info', detail: 'No action performed.', summary: ''});
              this.okToSave = false;
            }
        });
        return true;
    }

}
